import Wrapper from "../assets/wrappers/WorkedHourInfo";

const WorkedHourInfo = ({ icon, text }) => {
  return (
    <Wrapper>
      <span className="icon">{icon} </span>
      <span className="text">{text} </span>
    </Wrapper>
  );
};
export default WorkedHourInfo;
